import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { buttonContainerSX } from '@/components/blocks/DpLibrary/DpCardTendence/style/container';
import { imageTendenceSX } from '@/components/blocks/DpLibrary/DpCardTendence/style/image';
import {
	subtitleTendenceSX,
	titleTendenceSX,
} from '@/components/blocks/DpLibrary/DpCardTendence/style/typography';
import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { Grid, Typography } from '@mui/material';

export const DpCardTendence = ({
	title,
	subtitle,
	image,
	button,
	href,
	alt,
	loading,
	priority,
}: {
	title: string;
	subtitle: string;
	image: string;
	button: string;
	href?: string;
	alt?: string;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
	index?: number;
}) => (
	<Grid item xs={12} sm={6}>
		<Linkable href={href}>
			<Img
				src={image}
				alt={alt ?? title}
				sx={imageTendenceSX}
				loading={loading}
				priority={priority}
			/>
			<Typography component="h3" sx={titleTendenceSX}>
				{title}
			</Typography>
		</Linkable>
		<Typography sx={{ ...subtitleTendenceSX, mb: '14px', mt: '7px' }}> {subtitle} </Typography>
		<Grid sx={buttonContainerSX}>
			<Linkable href={href}>
				<DpButton text={button} />
			</Linkable>
		</Grid>
	</Grid>
);
